import React from "react";
import IxdaLogo from "../../IxdaLogo/IxdaLogo";

/**
 * Wraps IxdaLogo and scales it so that width/height match
 * the visible artwork (not the full 96x96 SVG viewBox).
 *
 * SVG artwork bounds: x 16–80 (64 wide), y 12.73–84 (71.27 tall).
 */
const ART_X = 16;
const ART_Y = 11.7;
const ART_W = 64;
const ART_H = 72.3;
const SVG_SIZE = 96;

const ScaledLogo = ({ color, width = 192, height = 221 }) => {
  const scale = width / ART_W;
  const svgSize = SVG_SIZE * scale;
  const offsetX = -(ART_X * scale);
  const offsetY = -(ART_Y * scale);

  return (
    <div
      style={{
        width,
        height,
        overflow: "hidden",
        flexShrink: 0,
      }}
    >
      <div
        style={{
          width: svgSize,
          height: svgSize,
          transform: `translate(${offsetX}px, ${offsetY}px) scale(${scale})`,
          transformOrigin: "top left",
        }}
      >
        <IxdaLogo color={color} />
      </div>
    </div>
  );
};

export default ScaledLogo;
